
/**
* Estou na store de anotacoes de currículo
*/

import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/features/vp/curriculo/minhasAnotacoes/store/index.js